// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ma-0";
export var discountCodeInput = "_ma-1";